var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgKakao = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE812",
    d: "M0 15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#381F1F",
    d: "M15 7.5c-4.832 0-8.75 3.108-8.75 6.942 0 2.479 1.638 4.654 4.101 5.882-.134.465-.86 2.992-.89 3.19 0 0-.017.15.079.207.096.057.209.013.209.013.275-.039 3.192-2.1 3.697-2.459.504.072 1.024.11 1.554.11 4.833 0 8.75-3.109 8.75-6.943 0-3.834-3.918-6.942-8.75-6.942Z"
  })));
});
SvgKakao.displayName = "SvgKakao";
export default SvgKakao;